import { combineReducers } from '@reduxjs/toolkit';
import bugsnag, { BugsnagState } from './BugsnagReducer';
import insights, { InsightsState } from './InsightsReducer';
import retool, { RetoolState } from './RetoolReducer';
import replit, { ReplitState } from './ReplitReducer';

export type ToolState = {
  bugsnag: BugsnagState;
  insights: InsightsState;
  retool: RetoolState;
  replit: ReplitState;
};

const ToolReducer = combineReducers({
  bugsnag,
  insights,
  retool,
  replit,
});

export default ToolReducer;
